  
/* src/features/FiveBreaths/FiveBreaths.js 
5BE Standalone Component
*/

import React, { useState, useEffect, useRef } from 'react';
// useNavigate removed — HomeButton links externally
   
  
	
 
   

import { db } from '../../apiClient';

// --- HELPER COMPONENTS ---

const Icon = ({ name, className }) => {
	   
  const faMap = {
    'chevron-left': 'fa-chevron-left',
    'play': 'fa-play',
    'x': 'fa-times',
    'check': 'fa-check',
    'loader-2': 'fa-spinner fa-spin',
    'home': 'fa-home' 
  };
  return <i className={`fas ${faMap[name] || ''} ${className}`}></i>;
};

// Reusable Home Button Component
const HomeButton = ({ color = 'white' }) => {
  return (
    <button
      onClick={() => { window.location.href = 'https://hashhouseyoga.com'; }}
      style={{
        position: 'absolute',
        left: '16px', 
        top: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: 'transparent', 
        border: 'none',
        color: color,
        cursor: 'pointer',
        fontSize: '1rem',
        fontWeight: '600',
        zIndex: 50, 
        textShadow: color === 'white' ? '0 1px 3px rgba(0,0,0,0.5)' : 'none',
        padding: '8px' 
      }}
    >
      <Icon name="home" />
      <span>Home</span>
    </button>
  );
};


// Breath slide data — image index maps to breath group (0-indexed)
const BREATH_SLIDES = [
  // First Breath — click to start, then auto-advance
  { text: 'Are you breathing?', image: 0, breath: 'First Breath' },
  // Second Breath
  { text: 'Take a deep breath', image: 1, breath: 'Second Breath' },
  { text: 'Have a deep exhale', image: 1, breath: 'Second Breath' },
  // Third Breath
  { text: 'Take a deep breath', image: 2, breath: 'Third Breath' },
  { text: 'Hold it in', image: 2, breath: 'Third Breath' },
  { text: 'Have a deep exhale', image: 2, breath: 'Third Breath' },
  { text: 'Hold it out', image: 2, breath: 'Third Breath' },
  // Fourth Breath
  { text: 'Do that again with your eyes closed.', image: 3, breath: 'Fourth Breath' },
  { text: 'Then let your body breathe on its own.', image: 3, breath: 'Fourth Breath' },
  { text: 'Stay in the Fourth Breath as long as you like.', image: 3, breath: 'Fourth Breath' },
  // Fifth Breath
  { text: 'When you open your eyes…', image: 4, breath: 'Fifth Breath' },
  { text: 'Return with a little bit of peace.', image: 4, breath: 'Fifth Breath' },
  { text: 'With love from the Hash House.', image: 4, breath: 'Fifth Breath' },
];

// 0. Choice page — listen to Yogi Cosmo or do the animation
const PageChoice = ({ onNavigate }) => {
  return (
    <div style={{
      height: '100vh', position: 'relative', overflow: 'hidden',
      backgroundColor: '#1c1917', display: 'flex', flexDirection: 'column'
    }}>
      {/* Background — use image1 */}
      <div style={{ position: 'fixed', inset: 0, zIndex: 0 }}>
        <img src="/assets/image1.png" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)' }} />
      </div>

      <HomeButton color="white" />

      <div style={{
        position: 'relative', zIndex: 20, flex: 1,
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', padding: '0 24px', gap: '20px'
      }}>
        <img
          src="/assets/hhy_logo.png" alt="Hash House Yoga"
          style={{ width: '80px', height: '80px', objectFit: 'contain', filter: 'brightness(0) invert(1)', marginBottom: '8px' }}
          onError={(e) => e.target.style.display = 'none'}
        />
        <h1 style={{
          fontSize: 'clamp(1.6rem, 5vw, 2.4rem)', fontWeight: 700, color: 'white',
          textAlign: 'center', lineHeight: 1.2, textShadow: '0 2px 8px rgba(0,0,0,0.5)',
          margin: 0
        }}>
          The 5 Breath Experience
        </h1>
        <p style={{
          fontSize: '1.1rem', color: 'rgba(255,255,255,0.85)', textAlign: 'center',
          textShadow: '0 1px 4px rgba(0,0,0,0.4)', maxWidth: '400px', margin: 0
        }}>
          Choose how you'd like to experience it
        </p>

        <div style={{
          display: 'flex', flexDirection: 'column', gap: '16px',
          width: '100%', maxWidth: '360px', marginTop: '16px'
        }}>
          <button
            onClick={() => onNavigate('page-5')}
            style={{
              width: '100%', padding: '18px 24px', borderRadius: '16px',
              backgroundColor: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)',
              border: '1px solid rgba(255,255,255,0.25)', color: 'white',
              fontSize: '1.15rem', fontWeight: 600, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
              transition: 'background-color 0.2s'
            }}
          >
            <Icon name="play" /> Listen to Yogi Cosmo
          </button>

          <button
            onClick={() => onNavigate('page-breathing')}
            style={{
              width: '100%', padding: '18px 24px', borderRadius: '16px',
              backgroundColor: '#059669', border: 'none', color: 'white',
              fontSize: '1.15rem', fontWeight: 600, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
              boxShadow: '0 8px 20px rgba(5,150,105,0.3)',
              transition: 'background-color 0.2s'
            }}
          >
            <i className="fas fa-wind" /> Guided Animation
          </button>
        </div>
      </div>
    </div>
  );
};

// 0b. Cosmo video page — fullscreen Yogi Cosmo intro
const PageCosmo = ({ onNavigate }) => {
  const videoRef = useRef(null);

  return (
    <div style={{ height: '100vh', backgroundColor: 'black', position: 'relative' }}>
      <HomeButton color="white" />

      {/* Back to choices */}
      <button
        onClick={() => onNavigate('page-1')}
        style={{
          position: 'absolute', right: '16px', top: '16px', zIndex: 50,
          background: 'rgba(0,0,0,0.4)', border: 'none', borderRadius: '50%',
          padding: '10px', cursor: 'pointer', color: 'white'
        }}
      >
        <Icon name="x" className="fa-lg" />
      </button>

      <video
        ref={videoRef}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        controls autoPlay playsInline
        onEnded={() => onNavigate('page-5')}
      >
        <source src="/assets/5DD_intro_cosmo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

// 1. Guided Breathing Animation
const PageBreathing = ({ onNavigate }) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [textVisible, setTextVisible] = useState(true);
  const [started, setStarted] = useState(false);
  const timerRef = useRef(null);

  const images = [
    '/assets/image1.png',
    '/assets/image2.png',
    '/assets/image3.png',
    '/assets/image4.png',
    '/assets/image5.png'
  ];

  const currentImageIndex = BREATH_SLIDES[slideIndex]?.image ?? 0;
  const currentBreathLabel = BREATH_SLIDES[slideIndex]?.breath || '';
  const isLastSlide = slideIndex >= BREATH_SLIDES.length - 1;

  const advanceSlide = () => {
    if (isLastSlide) {
      onNavigate('page-5');
      return;
    }
    setTextVisible(false);
    setTimeout(() => {
      setSlideIndex(prev => prev + 1);
      setTextVisible(true);
    }, 500);
  };

  useEffect(() => {
    if (!started || slideIndex === 0) return;
    timerRef.current = setTimeout(() => {
      advanceSlide();
    }, 3000);
    return () => clearTimeout(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideIndex, started]);

  const handleStart = () => {
    if (!started) {
      setStarted(true);
      advanceSlide();
    }
  };

  return (
    <div
      onClick={!started ? handleStart : undefined}
      style={{
        height: '100vh', position: 'relative', overflow: 'hidden',
        cursor: !started ? 'pointer' : 'default', userSelect: 'none'
      }}
    >
      {/* Background images with crossfade */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 0, backgroundColor: '#1c1917' }}>
        {images.map((src, index) => (
          <div
            key={index}
            style={{
              position: 'absolute', inset: 0,
              opacity: index === currentImageIndex ? 1 : 0,
              transition: 'opacity 1s ease-in-out'
            }}
          >
            <img
              src={src} alt=""
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.style.backgroundColor = '#292524';
              }}
            />
          </div>
        ))}
        <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.35)', zIndex: 10 }} />
      </div>

      <HomeButton color="white" />

      {/* Prompt text — positioned at ~40% from top */}
      <div style={{
        position: 'absolute', zIndex: 20,
        top: '40%', left: 0, right: 0,
        transform: 'translateY(-50%)',
        display: 'flex', justifyContent: 'center',
        padding: '0 24px'
      }}>
        <p style={{
          fontSize: 'clamp(1.6rem, 5vw, 2.6rem)', fontWeight: 600, color: 'white',
          textAlign: 'center', maxWidth: '700px', lineHeight: 1.3, margin: 0,
          textShadow: '0 2px 12px rgba(0,0,0,0.6)',
          opacity: textVisible ? 1 : 0, transition: 'opacity 0.5s ease-in-out'
        }}>
          {BREATH_SLIDES[slideIndex].text}
        </p>
      </div>

      {/* "Tap to begin" hint — above breath label */}
      {!started && (
        <span style={{
          position: 'absolute', zIndex: 20,
          bottom: '72px', left: 0, right: 0,
          textAlign: 'center',
          fontSize: '1rem', color: 'rgba(255,255,255,0.7)',
          textShadow: '0 1px 4px rgba(0,0,0,0.5)',
          animation: 'breathPulse 2s ease-in-out infinite'
        }}>
          tap to begin
        </span>
      )}

      {/* "Continue" prompt on last slide */}
      {isLastSlide && started && textVisible && (
        <button
          onClick={() => onNavigate('page-5')}
          style={{
            position: 'absolute', zIndex: 20,
            bottom: '72px', left: 0, right: 0,
            textAlign: 'center',
            background: 'transparent', border: 'none',
            color: 'rgba(255,255,255,0.8)', fontSize: '1.1rem',
            cursor: 'pointer', textShadow: '0 1px 4px rgba(0,0,0,0.5)',
            animation: 'breathPulse 2s ease-in-out infinite'
          }}
        >
          continue &darr;
        </button>
      )}

      {/* Breath label pinned to bottom */}
      <div style={{
        position: 'absolute', zIndex: 20,
        bottom: '32px', left: 0, right: 0,
        textAlign: 'center'
      }}>
        <span style={{
          fontSize: '1.1rem', fontWeight: 600, color: 'rgba(255,255,255,0.8)',
          textShadow: '0 1px 6px rgba(0,0,0,0.5)',
          opacity: currentBreathLabel ? 1 : 0,
          transition: 'opacity 0.5s ease',
          letterSpacing: '0.05em'
        }}>
          {currentBreathLabel}
        </span>
      </div>

      <style>{`
        @keyframes breathPulse {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

// 2. Page 2: SMS Entry Form
const PageSMS = ({ onNavigate, onShowModal }) => {
  const [formData, setFormData] = useState({ phone: '', email: '' });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    const newErrors = {};
    const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.phone.trim() && !formData.email.trim()) {
      newErrors.general = 'Please enter a phone number or an email address.';
    } else {
      if (formData.phone.trim() && !phoneRegex.test(formData.phone.trim())) {
        newErrors.phone = 'Please enter a valid 10-digit phone number.';
      }
      if (formData.email.trim() && !emailRegex.test(formData.email.trim())) {
        newErrors.email = 'Please enter a valid email address.';
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    
    try {
        try {
            await db.leads.create({ phone: formData.phone, email: formData.email, source: 'web_opt_in' });
            console.log("Lead logged");
        } catch (dbErr) {
            console.error("DB error:", dbErr);
        }
    } catch (error) {
        console.error("Error:", error);
    }
    
    await new Promise(resolve => setTimeout(resolve, 800));
    
    setIsSubmitting(false);
    setFormData({ phone: '', email: '' });
    onShowModal(); 
  };

  return (
    <div style={{height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#fafaf9', position: 'relative'}}>
      
								
      <HomeButton color="#374151" />

      <header style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 16px', marginTop: '10px'}}>
				 
					
				   
						
					  
	 
  
        <img src="/assets/hhy_logo.png" alt="HHY" style={{width: '64px', height: '64px', objectFit: 'contain'}} />
	
      </header>
      
      <main style={{
          flexGrow: 1, 
          padding: '0 16px', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'flex-start',
          alignItems: 'center',
          maxWidth: '500px', 
          margin: '0 auto', 
          width: '100%', 
          marginTop: '20px'
      }}>
        <h1 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#111827', textAlign: 'center', lineHeight: 1.2}}>
          You're one step away.
        </h1>
        <p style={{fontSize: '1.1rem', color: '#4b5563', marginTop: '10px', textAlign: 'center'}}>
          Enter your phone or email to join.
        </p>

        {errors.general && (
          <div style={{marginTop: '16px', padding: '12px', backgroundColor: '#fef2f2', border: '1px solid #fee2e2', color: '#b91c1c', borderRadius: '8px', textAlign: 'center', fontSize: '0.875rem', fontWeight: 500, width: '100%'}}>
            {errors.general}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '16px', width: '100%'}}>
          <div>
            <label htmlFor="phone" style={{display: 'block', fontSize: '0.875rem', fontWeight: 600, color: '#374151', marginBottom: '4px'}}>Phone Number (Optional)</label>
            <input
              type="tel"
              id="phone"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              style={{display: 'block', width: '100%', padding: '14px 16px', border: '1px solid #d1d5db', borderRadius: '12px', fontSize: '1.125rem', boxSizing: 'border-box'}}
              placeholder="(555) 123-4567"
            />
            {errors.phone && <p style={{color: '#ef4444', fontSize: '0.875rem', marginTop: '4px'}}>{errors.phone}</p>}
          </div>
          <div>
            <label htmlFor="email" style={{display: 'block', fontSize: '0.875rem', fontWeight: 600, color: '#374151', marginBottom: '4px'}}>Email (Optional)</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              style={{display: 'block', width: '100%', padding: '14px 16px', border: '1px solid #d1d5db', borderRadius: '12px', fontSize: '1.125rem', boxSizing: 'border-box'}}
              placeholder="you@example.com"
            />
             {errors.email && <p style={{color: '#ef4444', fontSize: '0.875rem', marginTop: '4px'}}>{errors.email}</p>}
          </div>
        </form>
        
		  
        <button 
            onClick={() => onNavigate('page-1')} 
            style={{marginTop: '20px', background: 'transparent', border: 'none', color: '#6b7280', cursor: 'pointer', textDecoration: 'underline'}}
        >
            &larr; Back to intro
        </button>

      </main>

      <footer style={{padding: '16px 24px', marginTop: 'auto', backgroundColor: 'white', borderTop: '1px solid #f3f4f6', width: '100%', boxSizing: 'border-box'}}>
         <div style={{maxWidth: '500px', margin: '0 auto', width: '100%'}}>
            <button 
              onClick={handleSubmit}
              disabled={isSubmitting}
              style={{
                width: '100%', backgroundColor: '#059669', color: 'white', fontWeight: 'bold', fontSize: '1.125rem', 
                padding: '16px 24px', borderRadius: '12px', border: 'none', cursor: isSubmitting ? 'not-allowed' : 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: isSubmitting ? 0.7 : 1
              }}
            >
              {isSubmitting ? <Icon name="loader-2" /> : "Send My Free Experience"}
            </button>
            <button 
              onClick={() => onNavigate('page-5')} 
              style={{width: '100%', marginTop: '12px', textAlign: 'center', color: '#6b7280', fontWeight: 500, padding: '12px 24px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '0.875rem'}}
            >
              Skip and watch video
            </button>
         </div>
      </footer>
    </div>
  );
};

// 3. Page 5: Video Experience
const PageVideo = ({ onNavigate }) => {
  const videoRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = () => {
    setIsFullscreen(true);
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.loop = false;
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(e => console.log("Autoplay prevented", e));
    }
  };

  const exitFullscreen = () => {
    setIsFullscreen(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.muted = true;
      videoRef.current.loop = true;
    }
  };

  const handleVideoEnd = () => {
    exitFullscreen();
  };

  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#fafaf9'}}>
      {/* Video Container */}
      <div 
        style={{
            position: isFullscreen ? 'fixed' : 'relative',
            inset: isFullscreen ? 0 : 'auto',
            zIndex: isFullscreen ? 50 : 'auto',
            width: '100%',
            height: isFullscreen ? '100vh' : '60vh',
            backgroundColor: 'black',
            transition: 'all 0.5s ease-in-out'
        }}
      >
        {/* GLOBAL HOME BUTTON - Hidden if Fullscreen */}
        {!isFullscreen && <HomeButton color="white" />}

        <video 
          ref={videoRef}
          style={{width: '100%', height: '100%', objectFit: isFullscreen ? 'contain' : 'cover'}}
          playsInline 
          loop={!isFullscreen}
          muted={!isFullscreen}
          preload="metadata"
          onEnded={handleVideoEnd}
          onClick={() => isFullscreen && exitFullscreen()}
        >
          <source src="/server_assets/five_breaths_opt.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {!isFullscreen && (
            <div style={{position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 10}} />
        )}

        {/* Fullscreen Controls */}
        {isFullscreen && (
            <>
	
                <img src="/assets/hhy_logo.png" alt="Logo" style={{position: 'absolute', top: '24px', left: '24px', width: '64px', height: '64px', zIndex: 30, filter: 'brightness(0) invert(1)'}} />
                <button 
                    onClick={exitFullscreen}
                    style={{position: 'absolute', top: '24px', right: '24px', zIndex: 30, padding: '12px', backgroundColor: 'rgba(0,0,0,0.4)', borderRadius: '50%', color: 'white', border: 'none', cursor: 'pointer'}}
                >
                    <Icon name="x" className="fa-2x" />
                </button>
            </>
        )}

        {/* Play Overlay */}
        <div style={{
            position: 'absolute', inset: 0, zIndex: 20, display: 'flex', flexDirection: 'column', color: 'white',
            opacity: isFullscreen ? 0 : 1, pointerEvents: isFullscreen ? 'none' : 'auto', transition: 'opacity 0.3s'
        }}>
            <header style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px 16px', marginTop: '20px'}}>
		  
	  
		 
  
	  
	
                <img src="/assets/hhy_logo.png" alt="HHY" style={{width: '64px', height: '64px', objectFit: 'contain', filter: 'brightness(0) invert(1)'}} />
	  
            </header>
            
            <main style={{flexGrow: 1, padding: '0 16px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}>
                <h1 style={{fontSize: '2rem', fontWeight: 'bold', color: 'white', textShadow: '0 4px 6px rgba(0,0,0,0.3)'}}>
                    The 5 Breath Experience
                </h1>
                <p style={{fontSize: '1.125rem', color: '#f3f4f6', marginTop: '16px', textShadow: '0 2px 4px rgba(0,0,0,0.3)'}}>
                    Tap to begin your practice.
                </p>
                
                <button 
                    onClick={enterFullscreen}
                    style={{marginTop: '32px', background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(4px)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '50%', padding: '24px', cursor: 'pointer'}}
                >
                     <Icon name="play" className="fa-3x" />
                </button>
            </main>
        </div>
      </div>

      {/* Documentation Section */}
      <section style={{padding: '24px', backgroundColor: 'white'}}>
        <div style={{maxWidth: '768px', margin: '0 auto'}}>
            <h2 style={{fontSize: '1.875rem', fontWeight: 'bold', color: '#111827', marginBottom: '24px'}}>The Five Breath Experience (5BE)</h2>
            
            <div style={{height: '384px', overflowY: 'auto', padding: '24px', backgroundColor: '#fafaf9', borderRadius: '12px', border: '1px solid #e7e5e4', color: '#374151'}}>
              <p style={{marginBottom: '16px', fontWeight: 500}}>
                The Five Breath Experience (5BE) is the core practice in Hash House Yoga (HHY). It is an immediate, on-demand calibration tool. The goal is simple: <strong>In five intentional breaths, you stop reacting and you start observing.</strong>
              </p>
              
              <h3 className="text-xl font-bold text-emerald-800 mt-6 mb-2">The Philosophy: Why the Five Breaths?</h3>
              <ul className="list-disc pl-5 space-y-2 mb-4">
                <li><strong>Establish a Baseline:</strong> Return to "factory settings" amidst constant change.</li>
                <li><strong>Regulate Flow:</strong> Space out tension and release throughout the day.</li>
                <li><strong>Distinguish Reality:</strong> Separate perceived crisis from actual reality.</li>
              </ul>

					
	 
              <h3 className="text-xl font-bold text-emerald-800 mt-6 mb-2">The Practice</h3>
              <p className="mb-4">Can be performed anywhere, anytime. The pattern follows a specific sequence:</p>
              
              <div className="space-y-4 mb-6">
                <div className="bg-white p-4 rounded-lg shadow-sm border border-stone-100">
                  <h4 className="font-bold text-emerald-700">1. Preparation</h4>
                  <p className="text-sm"><strong>Posture:</strong> Notice how you are positioned. No need to change, just notice.</p>
                  <p className="text-sm"><strong>Commitment:</strong> Consciously decide the next breaths are for self-use only.</p>
                </div>

                <div className="bg-white p-4 rounded-lg shadow-sm border border-stone-100">
                  <h4 className="font-bold text-emerald-700 mb-2">2. Execution (The Five Breaths)</h4>
                  <ul className="space-y-3">
                    <li className="text-sm"><strong className="block text-gray-900">Breath 1: Noticing</strong> Simply notice that you are breathing. Shift from unconscious to conscious.</li>
                    <li className="text-sm"><strong className="block text-gray-900">Breath 2: Capacity</strong> Execute a full inhale followed by a full, complete exhale. Maximize volume.</li>
                    <li className="text-sm"><strong className="block text-gray-900">Breath 3: Control (Box Breath)</strong> Inhale, Hold, Exhale, Hold (equal counts). Close your eyes if you haven't.</li>
                    <li className="text-sm"><strong className="block text-gray-900">Breath 4: Pivot</strong> Release control. Let the body breathe on its own. Observe the natural rhythm.</li>
                    <li className="text-sm"><strong className="block text-gray-900">Breath 5: Re-Entry</strong> Inhale and Exhale one last time with completion. Open eyes with a "squirt of love".</li>
                  </ul>
                </div>

	   
	 
		 
		   
	
              </div>

	   
		
	 
	
	 
   
	
	  
	  
	
  
	  
			 
			  
			
			 
		   
  
   
  
            </div>
        </div>
      </section>

      <footer style={{padding: '24px', textAlign: 'center', backgroundColor: 'white', borderTop: '1px solid #f3f4f6'}}>
        <span style={{fontSize: '0.875rem', color: '#6b7280'}}>Hash House Yoga © 2026</span>
      </footer>
    </div>
  );
};

// 4. Success Modal
const InfoModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;
    
    return (
        <div style={{position: 'fixed', inset: 0, zIndex: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)'}}>
            <div style={{backgroundColor: 'white', padding: '32px', borderRadius: '16px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', maxWidth: '448px', width: '100%', textAlign: 'center'}}>
                <div style={{width: '64px', height: '64px', backgroundColor: '#d1fae5', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px'}}>
                    <Icon name="check" className="text-emerald-600 fa-2x" />
                </div>
                <h3 style={{fontSize: '1.5rem', fontWeight: 'bold', color: '#111827'}}>Welcome!</h3>
                <p style={{color: '#4b5563', marginTop: '16px', fontSize: '1.125rem'}}>
                    We're adding you to the <strong>alpha and beta trials</strong>.
                </p>
                <p style={{color: '#059669', fontWeight: 500, marginTop: '8px', fontSize: '1.125rem'}}>
                    Look for your email.
                </p>
                <button 
                    onClick={onConfirm} 
                    style={{width: '100%', marginTop: '32px', backgroundColor: '#059669', color: 'white', fontWeight: 'bold', fontSize: '1.125rem', padding: '12px 24px', borderRadius: '12px', border: 'none', cursor: 'pointer'}}
                >
                    Got It
                </button>
            </div>
        </div>
    );
};


// --- Main Component ---
export default function FiveBreaths({ session }) {
  const [activePage, setActivePage] = useState('page-1');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Inject a style tag to override body/html padding and background on this page only
  useEffect(() => {
    const style = document.createElement('style');
    style.setAttribute('data-five-breaths', 'true');
    style.textContent = `
      body, html, #root {
        padding-top: 0 !important;
        background-image: none !important;
        background-color: #1c1917 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      style.remove();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activePage]);

  // Use the session passed from App.js
  const user = session?.user || null;

  const renderPage = () => {
    switch (activePage) {
      case 'page-1':
        return <PageChoice onNavigate={setActivePage} />;
      case 'page-cosmo':
        return <PageCosmo onNavigate={setActivePage} />;
      case 'page-breathing':
        return <PageBreathing onNavigate={setActivePage} />;
      case 'page-2':
        return <PageSMS onNavigate={setActivePage} onShowModal={() => setIsModalOpen(true)} />;
      case 'page-5':
        return <PageVideo onNavigate={setActivePage} />;
      default:
        return <PageChoice onNavigate={setActivePage} />;
    }
  };

  return (
    <div style={{fontFamily: 'sans-serif', color: '#1f2937', backgroundColor: '#fafaf9', minHeight: '100vh'}}>
      <InfoModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onConfirm={() => {
            setIsModalOpen(false);
            setActivePage('page-5'); 
        }}
      />
      <div style={{width: '100%'}}>
        {renderPage()}
      </div>
    </div>
  );
}